import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useForgotCode } from "api/auth";
import { useModal, useSnackbar } from "hooks";

import FormPhoneNumber from "../components/FormPhoneNumber";
import FormCodePassword from "../components/FormCodePassword";
import ModalTemplate from "../components/ModalTemplate";
import Congrats from "../components/Congrats";
import useSteps from "hooks/useSteps";
import { ReactComponent as ErrorSVG } from 'assets/icons/snackbar/error.svg'


const Recovery = () => {

  const { t } = useTranslation()
  const { Modal: ModalLogin } = useModal('login')

  const { Snackbar } = useSnackbar('error')
  const { step, nextStep, prevStep } = useSteps()

  const {
    forgotCode,
    isLoading: isForgotLoading,
    isSuccess: isForgotSuccess,
    error: forgotError,
  } = useForgotCode()


  const [country, setCountry] = useState()
  const [mobileNumber, setMobileNumber] = useState('')

  const handleForgot = ({ mobileNumber }) => forgotCode({ mobileNumber })

  const errorInput = forgotError && forgotError?.code !== 412 && t('mobileNumberUnknown')


  useEffect(() => {
    if (isForgotSuccess) nextStep()
  }, [isForgotSuccess])

  useEffect(() => {
    if (!forgotError) return

    if (forgotError.code === 412) {
      Snackbar.open({
        icon: ErrorSVG,
        message: t('operationLimitExceeded')
      })
    }

  }, [forgotError])


  if (step === 0) return (
    <ModalTemplate
      flowTitle={t('recoverPassword')}
      currentStep={1}
      totalSteps={2}
      onBack={ModalLogin.open}
    >
      <FormPhoneNumber
        title={t('enterYourMobileNumber')}
        country={country}
        setCountry={setCountry}
        mobileNumber={mobileNumber}
        setMobileNumber={setMobileNumber}
        onSubmit={handleForgot}
        isLoading={isForgotLoading}
        error={errorInput}
      />
    </ModalTemplate>
  )


  if (step === 1) return (
    <ModalTemplate
      flowTitle={t('recoverPassword')}
      currentStep={2}
      totalSteps={2}
      onBack={prevStep}
    >
      <FormCodePassword
        onSuccess={nextStep}
        mobileNumber={`${country?.value}${mobileNumber}`}
      />
    </ModalTemplate>
  )


  if (step === 2) return (
    <Congrats
      title={t('passwordRecoverySuccessfull')}
      description={t('nowYouCanLoginWithNewPwd')}
    />
  )
}

export default Recovery